(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7806],{

/***/ 57806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Content050": function() { return /* binding */ Content050; },
  "default": function() { return /* binding */ Content050_Content050; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/shared/components/index.js + 114 modules
var components = __webpack_require__(47696);
// EXTERNAL MODULE: ./src/components/widgets/content/Content050/Content050.module.scss
var Content050_module = __webpack_require__(29428);
var Content050_module_default = /*#__PURE__*/__webpack_require__.n(Content050_module);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/RichTextWidget/index.js + 11 modules
var RichTextWidget = __webpack_require__(14258);
// EXTERNAL MODULE: ./src/features/translations/index.js + 3 modules
var translations = __webpack_require__(91929);
// EXTERNAL MODULE: ./src/components/widgets/content/Content050/Items/Items.module.scss
var Items_module = __webpack_require__(16041);
var Items_module_default = /*#__PURE__*/__webpack_require__.n(Items_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content050/Items/Items.jsx






var AMOUNT_ITEMS = {
    default: "three",
    3: "three",
    4: "four",
    5: "five"
};
var Items = function(param) {
    var items = param.items;
    var t = (0,translations/* useTranslation */.$)().t;
    var itemsAmount = AMOUNT_ITEMS[items.length] || AMOUNT_ITEMS.default;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((Items_module_default()).items, (Items_module_default())[itemsAmount]),
        children: items.map(function(item) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PageLink */.H_, {
                link: item.link,
                target: item.target,
                className: (Items_module_default()).link,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Items_module_default()).item,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Items_module_default()).text,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading5 */.by, {
                                    className: (Items_module_default()).title,
                                    color: "dark",
                                    children: item.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextWidget/* RichText */.H, {
                                    className: (Items_module_default()).description,
                                    value: item.description
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Items_module_default()).button,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (Items_module_default()).arrow,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                        className: (Items_module_default()).icon,
                                        name: "arrow_right"
                                    })
                                }),
                                item.online && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                    color: "light",
                                    className: (Items_module_default()).online,
                                    appearance: "bigger",
                                    children: t("online")
                                })
                            ]
                        })
                    ]
                })
            }, item.id);
        })
    });
};

;// CONCATENATED MODULE: ./src/components/widgets/content/Content050/Items/index.js


;// CONCATENATED MODULE: ./src/components/widgets/content/Content050/Content050.jsx




var Content050 = function(param) {
    var payload = param.payload;
    var ref;
    var title = (ref = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var projects = (ref1 = payload === null || payload === void 0 ? void 0 : payload.links) !== null && ref1 !== void 0 ? ref1 : [];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Content050_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Container */.W2, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Content050_module_default()).block,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading3 */.aC, {
                        className: (Content050_module_default()).title,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Content050_module_default()).content
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Items, {
                        items: projects
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Content050_Content050 = (Content050);


/***/ }),

/***/ 29428:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content050_wrapper__tY5qn","title":"Content050_title__lvfHh"};

/***/ }),

/***/ 16041:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"items":"Items_items__8aMJn","item":"Items_item__hPKBw","link":"Items_link__P6Dzw","three":"Items_three__FbvhZ","four":"Items_four__GtDdD","five":"Items_five__J84Hp","text":"Items_text__uy0Nm","title":"Items_title__BVcEg","online":"Items_online__nEB78","button":"Items_button__Qr9Hz","arrow":"Items_arrow__POEAt","icon":"Items_icon__vBGWV"};

/***/ })

}]);